export enum EnumSection {
  ComingSoon = -9,
  Financing = -8,
  PrivacyPolicy = -3,
  TermsAndConditions = -2,
  Home = -1,
  About = 0,
  Mission,
  News,
  Features,
  Pricing,
  Team,
  Resources,
  Showcases,
  Notebooks,
  Sfn2025,
  Gallery,
  Contact,
  Story,
}
